/**
 * Best-effort message from Axios-style errors (portal API responses).
 */
export function getApiErrorMessage(error: unknown): string {
  if (error && typeof error === "object" && "response" in error) {
    const data = (error as { response?: { data?: { message?: string } } }).response?.data;
    if (data && typeof data.message === "string") return data.message;
  }
  if (error instanceof Error) return error.message;
  return "";
}

/**
 * Machine-readable error code from a portal API error. The backend puts `code`
 * at the TOP level of the body, alongside `message` (functions/responses/index.js).
 */
export function getApiErrorCode(error: unknown): string | null {
  if (error && typeof error === "object" && "response" in error) {
    const data = (error as { response?: { data?: { code?: unknown } } }).response?.data;
    if (data && typeof data.code === "string" && data.code.trim()) return data.code;
  }
  return null;
}
